import { render } from "./IconDropdown.vue?vue&type=template&id=a9b9d698&scoped=true"
import script from "./IconDropdown.vue?vue&type=script&lang=js"
export * from "./IconDropdown.vue?vue&type=script&lang=js"

import "./IconDropdown.vue?vue&type=style&index=0&id=a9b9d698&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b9d698"]])

export default __exports__